import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "radioTuneFilled"
const RadioTuneFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M17.695 1.564C18.074 1.396 18.517 1.567 18.685 1.945S18.684 2.767 18.306 2.935L8.035 7.5H21C21.828 7.5 22.5 8.17 22.5 9V20.25C22.5 21.078 21.828 21.75 21 21.75H3C2.172 21.75 1.5 21.078 1.5 20.25V9C1.5 8.17 2.172 7.5 3 7.5H4.34zM15.375 10.874C13.304 10.875 11.625 12.555 11.625 14.625 11.625 16.697 13.304 18.375 15.375 18.375S19.125 16.697 19.125 14.625C19.125 12.555 17.446 10.875 15.375 10.875M4.5 14.25V15.75H7.5C8.328 15.75 9 15.078 9 14.25zM4.5 11.25V12.75H7.5C8.328 12.75 9 12.078 9 11.25z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default RadioTuneFilledIcon
